import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { EndpointsService } from "../../services/endpoints/endpoints.service";
import { setCookieToken, setLocalStorageUser } from "../../services/session/auth.service";
import Header from "../../components/header/Header.component";
import { setAuth0 } from "../../services/auth0/auth0.service";
import { ThemeService } from "../../services/theme/ThemeService.service";

const Callback = () => {
	const auth0 = useAuth0();
	const navigate = useNavigate();

	useEffect(() => {
		console.log(
			`Auth0 loading: ${auth0.isLoading}, authenticated: ${auth0.isAuthenticated}, error: ${auth0.error}`
		);
		setAuth0(auth0);
	}, [auth0.isLoading, auth0.isAuthenticated, auth0.error]);

	// Login failed
	if (auth0.error) {
		const errorType =
			auth0.error?.message === "unauthorized_to_signin"
				? "unauthorized_to_signin"
				: "unknown";
		auth0.logout({
			logoutParams: {
				returnTo: window.location.origin + `/login?errorType=${errorType}`,
			},
		});
	}

	// Login succeeded
	if (auth0.isAuthenticated) {
		auth0.getAccessTokenSilently().then(async (token) => {
			setCookieToken(token);
			try {
				// Get participant information
				const response = await EndpointsService.dataRetriever.getParticipantInfo();
				setLocalStorageUser(response);

				// Go to the main page
				navigate("/", { replace: true });
			} catch (_) {
				auth0.logout({
					logoutParams: {
						returnTo: window.location.origin + "/login?errorType=unknown",
					},
				});
			}
		});
	}

	// This is a guard. If the user is not authenticated and there's no error, it means that the user accessed directly the callback page.
	//  In this case we should reditect to the login page
	if (!auth0.isAuthenticated && !auth0.error && !auth0.isLoading) {
		navigate("/login", { replace: true });
	}

	/**
	 * Changing the secret provided by Auth0 for an access token (last step in the login flow)
	 *  is done by their SDK but it takes sometime.
	 *
	 * Meanwhile we're doing this we want to show a fake layout to the user (non clickable header & sidebar + empty content)
	 *  simulating that he's already authenticated.
	 *  By doing this the perceived speed of the app will be faster on the eyes of the user.
	 */

	useEffect(() => {
		/**
		 * Theme:
		 * Now that the user has logged in, update the theme based on his brand identity
		 */
		ThemeService.setTheme();
	}, []);

	return (
		<div style={{ pointerEvents: "none" }}>
			<Header />
		</div>
	);
};

export default Callback;
